export default __webpack_public_path__ + "static/media/Indoor Placeholder.0f4bc9d5.png";